import { reactive, toRefs } from 'vue'

export const componentState = ({ data }) => {
  const state = reactive({
    typeName: data.typeName
  })

  return { ...toRefs(state) }
}
